const connection = navigator.connection;
const canPrefetch = () => !Shopify.designMode && !connection?.saveData && !/^(slow-2g|2g)$/.test(connection?.effectiveType || '');
const eligible = (link) => {
  if (!link || link.target && link.target !== '_self' || link.hasAttribute('download')) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || url.search || url.hash || url.pathname === location.pathname) return;
  const root = Shopify.routes.root;
  const path = url.pathname.slice(root.length);
  if (!/^(products|collections|pages)\//.test(path)) return;
  return url;
};

// Let the browser own the short-lived document cache and concurrency budget.
// Moderate eagerness waits for clear link intent, rather than downloading
// every route or running a second client-side navigation system.
if (canPrefetch() && HTMLScriptElement.supports?.('speculationrules')) {
  const script = document.createElement('script');
  script.type = 'speculationrules';
  const root = Shopify.routes.root;
  script.textContent = JSON.stringify({ prefetch: [{
    source: 'document',
    where: { and: [
      { href_matches: [`${root}products/*`, `${root}collections/*`, `${root}pages/*`] },
      { not: { href_matches: location.href } },
      { selector_matches: 'a[href]:not([href*="?"]):not([href*="#"]):not([download]):is(:not([target]),[target="_self"])' }
    ] },
    eagerness: 'moderate'
  }] });
  document.head.appendChild(script);
  connection?.addEventListener('change', () => { if (!canPrefetch()) script.remove(); });
} else if (canPrefetch()) {
  const warmed = new Set();
  let timer;
  const warm = (link) => {
    const url = eligible(link);
    if (!canPrefetch() || !url || warmed.has(url.href) || warmed.size >= 2) return;
    warmed.add(url.href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch'; hint.href = url.href; hint.as = 'document';
    document.head.appendChild(hint);
  };
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(timer);
    const link = event.target.closest?.('a[href]');
    timer = setTimeout(() => warm(link), 100);
  }, { passive: true });
  document.addEventListener('pointerout', () => clearTimeout(timer), { passive: true });
  document.addEventListener('focusin', (event) => warm(event.target.closest?.('a[href]')));
}
